module.exports = __webpack_public_path__ + "img/chargingpoint-rejected.d92e0291.svg";